module.exports = __webpack_public_path__ + "static/media/turismo-coimbra.e04b19b3.svg";